import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportBatchPayload {
  customerId: string;
  templateId: string;
  declarantId: string;
  userId: string;
  file: File;
}

export const useAdminImportBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportBatchPayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('customerId', payload.customerId);
      formData.append('templateId', payload.templateId);
      formData.append('declarantId', payload.declarantId);
      formData.append('userId', payload.userId);

      await request({
        path: 'admin/import-batch',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['admin-batches'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import batch');
    },
  });
};
